import { useAtom } from "jotai";
import { useEffect } from "react";
import { authAtom, userAtom } from "../store/atoms";
import { extractUserInfoFromToken } from "../utils/auth";
import { storage } from "../utils/storage";

export const useAuth = () => {
  const [auth, setAuth] = useAtom(authAtom);
  const [user, setUser] = useAtom(userAtom);

  // 앱 시작 시 localStorage에서 토큰 확인하여 로그인 상태 초기화
  useEffect(() => {
    const initializeAuth = () => {
      const accessToken = storage.getAccessToken();

      if (accessToken) {
        // JWT 토큰에서 사용자 정보 추출
        const userInfo = extractUserInfoFromToken(accessToken);
        if (userInfo) {
          setUser({
            id: userInfo.userId,
            name: userInfo.userName,
            email: userInfo.email,
          });
        }
      }

      setAuth((prev) => ({
        ...prev,
        isLoggedIn: !!accessToken,
        accessToken,
        isInitialized: true,
      }));
    };

    if (!auth.isInitialized) {
      initializeAuth();
    }
  }, [auth.isInitialized, setAuth, setUser]);

  // 로그인 처리
  const login = (accessToken: string, refreshToken?: string) => {
    storage.setAccessToken(accessToken);

    if (refreshToken) {
      storage.setRefreshToken(refreshToken);
    }

    // JWT 토큰에서 사용자 정보 추출
    const userInfo = extractUserInfoFromToken(accessToken);
    if (userInfo) {
      setUser({
        id: userInfo.userId,
        name: userInfo.userName,
        email: userInfo.email,
      });
    }

    setAuth({
      isLoggedIn: true,
      accessToken,
      isInitialized: true,
    });
  };

  // 로그아웃 처리
  const logout = () => {
    storage.removeAccessToken();
    storage.removeRefreshToken();

    // 사용자 정보 초기화
    setUser({
      id: null,
      name: "",
      email: "",
    });

    setAuth({
      isLoggedIn: false,
      accessToken: null,
      isInitialized: true,
    });
  };

  return {
    isLoggedIn: auth.isLoggedIn,
    accessToken: auth.accessToken,
    isInitialized: auth.isInitialized,
    user,
    login,
    logout,
  };
};
